import {Box} from '../../components/core/view';
import React from 'react';

const ApplicationStatusScreen = () => {
  return <Box />;
};

export default React.memo(ApplicationStatusScreen);
